import { v4 as uuidv4 } from 'uuid';

import { IBackendCartEntries, ICartEntry } from '@rbi-ctg/menu';
import { CartEntryType } from 'utils/cart';
import { parseMaybeJson } from 'utils/parse-string';

export const mapBackendToFrontend = (
  cartEntry: IBackendCartEntries,
  isChildOfCombo?: boolean
): ICartEntry => {
  const id = cartEntry.sanityId || '';
  const children = parseMaybeJson<IBackendCartEntries[]>(cartEntry.children, []);
  const image = parseMaybeJson<ICartEntry['image']>(cartEntry.image, undefined);
  const pickerSelections = parseMaybeJson<ICartEntry['pickerSelections']>(
    cartEntry.pickerSelections,
    {}
  );

  return {
    _id: id,
    cartId: uuidv4(),
    children: children.map((entry: IBackendCartEntries) =>
      mapBackendToFrontend(
        entry,
        [CartEntryType.combo, CartEntryType.comboSlot].includes(cartEntry.type)
      )
    ),
    image,
    name: cartEntry.name || '',
    pickerSelections,
    // NOTE: Currently this util does not price anything. It will return zero for all prices
    // If you need prices the useMapToFrontendCartEntry hook will reprices/repair selections for you. (https://github.com/rbilabs/ctg-whitelabel-app/blob/master/workspaces/frontend/src/state/order/hooks/use-map-to-frontend-cart-entry.ts)
    quantity: cartEntry.quantity,
    reorder: true,
    isDonation: cartEntry.isDonation ?? false,
    isExtra: cartEntry.isExtra ?? false,
    sanityId: id,
    type: cartEntry.type,
    url: cartEntry.url,
    offerVendorConfigs: cartEntry.offerVendorConfigs,
    vendorConfigs: cartEntry.vendorConfigs,
    // prevents double price in the cart
    // we don't want to include price for direct children items of combos and comboslots (main items)
    ...(!isChildOfCombo && { price: 0 }),
  };
};
